import { Injectable } from '@angular/core'
import { ActivationEnd, NavigationCancel, NavigationError, NavigationStart, Router } from '@angular/router'
import { Observable, Subject } from 'rxjs'
import { distinctUntilChanged, debounceTime, take, filter } from 'rxjs/operators'
import { Logger } from 'common/log'
import { IdentityService } from 'main/services/identity.service'

@Injectable({ providedIn: 'root' })
export class RouteLoggerService {
  private routeChanging = new Subject<boolean>()
  private logger = new Logger(__filename)
  routeChanging$: Observable<boolean> = this.routeChanging.pipe(
    distinctUntilChanged(),
    debounceTime(10),
  )
  lastError?: any

  constructor (
    private identity: IdentityService,
    router: Router,
  ) {
    this.patchNavigationForSessionKeys()
    this.patchLinkClickingForSessionKeys()

    this.routeChanging$.pipe(filter(x => !x), take(1)).subscribe(() => {
      document.querySelector('.app-splashscreen')?.remove()
    })

    router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.setRouteIsChanging(true)
        this.logger.group('Navigating to', event.url)
      }
      if (event instanceof ActivationEnd) {
        this.logger.groupEnd()
        if (event.snapshot.data['ignoreEvents']) {
          return
        }
        this.setRouteIsChanging(false)
      }
      if ((event instanceof NavigationCancel) ||
        (event instanceof NavigationError)
      ) {
        this.setRouteIsChanging(false)
        this.logger.warn('Route rejection:', event)
        this.logger.groupEnd()
      }
    })
  }

  setRouteIsChanging (value: boolean): void {
    this.routeChanging.next(value)
    document.body.classList.toggle('route-changing', value)
  }

  private patchNavigationForSessionKeys () {
    for (const method of ['pushState', 'replaceState']) {
      const original = history[method]
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const self = this
      history[method] = function (state, _, url, ...args) {
        return original.call(this, state, _, self.identity.patchURLWithSessionKey(url), ...args)
      }
    }
  }

  private patchLinkClickingForSessionKeys () {
    document.addEventListener('mousedown', e => {
      let target: HTMLElement|null = e.target as HTMLElement
      while (target && target.tagName !== 'A') {
        target = target.parentElement
      }
      if (target) {
        const href = target.getAttribute('href')
        if (href) {
          target.setAttribute('href', this.identity.patchURLWithSessionKey(href))
        }
      }
    })
  }
}
